import { Box, Card, CardContent, Grid, Typography } from '@mui/material'

export const MetricCard = ({
	label,
	value,
	change,
	icon,
	bgColor = '#E8F2FB',
	changeColor = 'var(--success)',
}) => {
	return (
		<Card
			sx={{
				boxShadow: 'none',
				height: '100%',
				border: '1px solid var(--border)',
				borderRadius: '12px',
				transition: 'all 0.2s ease',
				'&:hover': {
					boxShadow: 'none',
				},
			}}
		>
			<CardContent>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'flex-start',
					}}
				>
					<Box>
						<Typography
							variant="body2"
							sx={{
								color: 'var(--primary-Text)',
								mb: 1,
								font: 'var(--body-font-three)',
								fontWeight: 600,
							}}
						>
							{label}
						</Typography>
						<Typography
							variant="h4"
							sx={{
								mb: 1,
								color: 'var(--primary-Text)',
								font: 'var(--h3)',
								fontWeight: 700,
							}}
						>
							{value}
						</Typography>
						<Typography
							variant="caption"
							sx={{
								color: changeColor,
								font: 'var(--body-font-four)',
								fontWeight: 400,
							}}
						>
							{change}
						</Typography>
					</Box>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<img
							src={icon || '/placeholder.svg'}
							alt={label}
							width={24}
							height={24}
							style={{ objectFit: 'contain' }}
						/>
					</Box>
				</Box>
			</CardContent>
		</Card>
	)
}

export const MetricCards = ({ cards }) => {
	return (
		<Grid container spacing={3}>
			{cards.map((card, index) => (
				<Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
					<MetricCard {...card} />
				</Grid>
			))}
		</Grid>
	)
}